import { CalendarStore } from "@/Appointments/Stores/CalendarStore";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class CalendarPrintDialogsHandler extends BaseOperationHandler {
    private readonly helper: MyleHelper;

    constructor() {
        super();

        this.helper = new MyleHelper();

        this.RegisterOperation(LocalOperations.Calendar.Checkbox_Change, this.OnCheckboxChange);

        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintDialog_Cancel_Click, this.CalendarPrintDialogCancelClick);
        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintDialog_Print_Click, this.CalendarPrintDialogPrintClick);

        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintByDoctorDialog_Cancel_Click, this.CalendarPrintByDoctorDialogCancelClick);
        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintByDoctorDialog_EraseAll_Click, this.CalendarPrintByDoctorDialogEraseAllClick);
        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintByDoctorDialog_Print_Click, this.CalendarPrintByDoctorDialogPrintClick);
        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintByDoctorDialog_EmployeeFilterChange, this.CalendarPrintByDoctorDialogOnEmployeeFilterChange);
        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintByDoctorDialog_ClinicianPrintOptionChange, this.CalendarPrintByDoctorOnPrintOptionChange);
        this.RegisterOperation(LocalOperations.Calendar.Calendar_PrintDialog_ClinicianPrintOptionChange, this.CalendarPrintDialogOnPrintOptionChange);
    }

    private OnCheckboxChange(request: LocalEvent, store: CalendarStore): void {
        var target = request.Get<CheckboxTarget>("target");
        var checked = request.Get<boolean>("checked");
        var id = request.Get<string>("id");

        switch (target) {
            case CheckboxTarget.Myle_Calendar_PrintByDoctor_SearchSites:
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("IsAllSitesChecked", checked);
                var sites = store.helper.ChangeCheckStateFromAllICheckable(store.calendarPrintByDoctorModel.get("Sites"), checked);
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("Sites", sites);
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesFiltered", store.GetEmployeesBasedOnSitesAndQuery_PrintDialog());
                break;
            case CheckboxTarget.Myle_Calendar_PrintByDoctor_SiteItem:
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("Sites", store.helper.FindUpdateICheckableItem<SiteUIModel>(store.calendarPrintByDoctorModel.get("Sites"), id, checked));
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesFiltered", store.GetEmployeesBasedOnSitesAndQuery_PrintDialog());
                break;
            case CheckboxTarget.Myle_Calendar_PrintByDoctor_SearchEmployees:
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("IsAllEmployeesChecked", checked);
                var list = store.GetEmployeesBasedOnSitesAndQuery_PrintDialog();
                var listOfClinicianIds = list.toArray().map(i => i.Id);
                var c = store.helper.FindUpdateICheckableItems(store.calendarPrintByDoctorModel.get("EmployeesGlobalCache"), listOfClinicianIds, checked);
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesGlobalCache", c);
                var checkedList = store.GetEmployeesBasedOnSitesAndQuery_PrintDialog();
                var checkedListIds = checkedList.toArray().map(i => i.Id);
                var setCheckedList = store.helper.FindUpdateICheckableItems(store.calendarPrintByDoctorModel.get("EmployeesFiltered"), checkedListIds, checked);
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesFiltered", setCheckedList);
                break;
            case CheckboxTarget.Myle_Calendar_PrintByDoctor_EmployeeItem:
                store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesFiltered", store.helper.FindUpdateICheckableItem<EmployeeUIModel>(store.calendarPrintByDoctorModel.get("EmployeesFiltered"), id, checked));
                break;
            default:
                break;
        }
    }

    private CalendarPrintDialogCancelClick(request: LocalEvent, store: CalendarStore): void {
        store.calendarModel = store.calendarModel.set("IsPrintCalendarDialogVisible", false);
    }

    private CalendarPrintDialogPrintClick(request: LocalEvent, store: CalendarStore): void {
        // this dialog prints the current view [employees + date span]
        store.calendarActions.PrintAppointments(store, false);
    }

    private CalendarPrintByDoctorDialogCancelClick(request: LocalEvent, store: CalendarStore): void {
        store.calendarModel = store.calendarModel.set("IsPrintMDDialogVisible", false);
    }

    private CalendarPrintByDoctorDialogEraseAllClick(request: LocalEvent, store: CalendarStore): void {
        var sites = store.calendarPrintByDoctorModel.get("Sites");
        var employees = store.calendarPrintByDoctorModel.get("EmployeesGlobalCache");
        var filteredEmployees = store.calendarPrintByDoctorModel.get("EmployeesFiltered");
        sites = this.helper.ChangeCheckStateFromAllICheckable(sites, false);
        employees = this.helper.ChangeCheckStateFromAllICheckable(employees, false);
        filteredEmployees = this.helper.ChangeCheckStateFromAllICheckable<EmployeeUIModel>(filteredEmployees, false);

        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("Sites", sites);
        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesGlobalCache", employees);
        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesFiltered", filteredEmployees);
        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("IsAllEmployeesChecked", false);
        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("IsAllSitesChecked", false);
        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesFiltered", store.GetEmployeesBasedOnSitesAndQuery_PrintDialog());
    }

    private CalendarPrintByDoctorDialogPrintClick(request: LocalEvent, store: CalendarStore): void {
        store.calendarActions.PrintAppointments(store, true);
    }

    private CalendarPrintByDoctorDialogOnEmployeeFilterChange(request: LocalEvent, store: CalendarStore): void {
        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesSearchText", request.Get<string>("value"));
        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("EmployeesFiltered", store.GetEmployeesBasedOnSitesAndQuery_PrintDialog());
    }

    private CalendarPrintByDoctorOnPrintOptionChange(request: LocalEvent, store: CalendarStore): void {
        const value = request.Get<KeyValuePair<string, string>>("value");

        store.calendarPrintByDoctorModel = store.calendarPrintByDoctorModel.set("SelectedPrintOption", value.Value);
    }

    private CalendarPrintDialogOnPrintOptionChange(request: LocalEvent, store: CalendarStore): void {
        const value = request.Get<KeyValuePair<string, string>>("value");

        store.calendarPrintDialogModel = store.calendarPrintDialogModel.set("SelectedPrintOption", value.Value);
    }
}

export { CalendarPrintDialogsHandler };
